import { getOwner } from "@ember/application"
import { action } from "@ember/object"
import { inject as service } from "@ember/service"
import Component from "@glimmer/component"
import analyticsOnly from "cc-frontend/lib/actions/analytics-only"
import type Router from "cc-frontend/router"
import type Dispatcher from "cc-frontend/services/dispatcher"
import type Rpc from "cc-frontend/services/rpc"
import type Session from "cc-frontend/services/session"
import { TrackedObject } from "tracked-built-ins"

interface Args {
  encounteredServerError: boolean
  isCompleted: boolean
}

export default class UserEditPassword extends Component<Args> {
  @service dispatcher!: Dispatcher
  @service session!: Session
  @service appState
  @service rpc!: Rpc

  state = new TrackedObject({
    password: null as string | null,
    passwordConfirmation: null as string | null,
    passwordsUnmatchedError: false,
  })

  @action onSubmit(e) {
    e.preventDefault()
    this.dispatcher.dispatchPreparedAction(
      analyticsOnly({ titleForAnalytics: "User - Change Password" })
    )

    let password = this.state.password
    let passwordConfirmation = this.state.passwordConfirmation
    let passwordsMatch = password === passwordConfirmation
    let isValidPassword = (password ?? "").length >= 8
    if (passwordsMatch !== true || isValidPassword !== true) {
      this.dispatcher.dispatchPreparedAction(
        analyticsOnly({ titleForAnalytics: "User - Edit Password Error - Passwords don't match" })
      )
      this.state.passwordsUnmatchedError = true
      return
    }
    this.rpc
      .execute("CHANGE_PASSWORD", password)
      .then((result) =>
        // @ts-ignore
        (getOwner(this)!.lookup("router:main") as Router).transitionTo({
          queryParams: { completed: true },
        })
      )
      .catch((result) => {
        console.log("error", result)
        // @ts-ignore
        ;(getOwner(this)!.lookup("router:main") as Router).transitionTo({
          queryParams: { serverError: true },
        })
      })
  }
}
